import { Button, Text } from '@user-portal/wikr-components';
import { HTMLAttributes } from 'react';
import styled from 'styled-components';

import mediaQueries from 'theme/mediaQueries';
import { borderRadius, color } from 'theme/selectors';

import CheckIcon from 'assets/images/workoutPlan/checkIcon.svg';

const BASE_Z_INDEX = 1;
const DEFAULT_CARD_HEIGHT_MOBILE = 180;
const DEFAULT_CARD_HEIGHT_LAPTOP = 200;

const DEFAULT_DONE_CARD_HEIGHT_MOBILE = 118;
const DEFAULT_DONE_CARD_HEIGHT_LAPTOP = 132;

const getCardHeight = (done: boolean, laptop: boolean) => {
    if (done) {
        return `${laptop ? DEFAULT_DONE_CARD_HEIGHT_LAPTOP : DEFAULT_DONE_CARD_HEIGHT_MOBILE}px`;
    }

    return `${laptop ? DEFAULT_CARD_HEIGHT_LAPTOP : DEFAULT_CARD_HEIGHT_MOBILE}px`;
};

export const Item = styled.li<{ $done: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: ${({ $done }) => getCardHeight($done, false)};
    padding: 16px;
    width: 100%;
    text-align: left;
    background: ${color('surface-default')};
    border-radius: ${borderRadius('medium')};
    ${({ $done }) =>
        $done &&
        `
            background: linear-gradient(
                71deg,
                rgba(40, 42, 43, 1) 0%,
                rgba(40, 42, 43, 1) 55%,
                rgba(40, 42, 43, 1) 75%,
                rgba(26, 51, 117, 1) 100% );
        `};

    ${mediaQueries.laptop} {
        min-height: ${({ $done }) => getCardHeight($done, true)};
        padding: 20px;
    }
`;

export const StartButton = styled(Button)`
    &&& {
        max-width: 160px;
        min-height: 44px;
    }
    z-index: ${BASE_Z_INDEX};

    ${mediaQueries.laptop} {
        &&& {
            max-width: 200px;
        }
    }
`;

export const ButtonText = styled.span`
    font-size: 14px;
`;

export const InfoContainer = styled.div`
    max-width: 60%;
    z-index: ${BASE_Z_INDEX};

    ${mediaQueries.laptop} {
        max-width: 70%;
    }
`;

export const PlanName = styled(Text)`
    &&& {
        font-size: 21px;
        line-height: 32px;
    }

    margin-bottom: 2px;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;

    ${mediaQueries.laptop} {
        &&& {
            font-size: 24px;
        }
        margin-bottom: 4px;
    }
`;

export const Duration = styled(Text)<{ $mb?: number }>`
    &&& {
        font-size: 14px;
        line-height: 20px;
        color: ${color('text-secondary-subdued')};
    }
    ${({ $mb }) => $mb && `margin-bottom: ${$mb}px;`};

    ${mediaQueries.laptop} {
        &&& {
            font-size: 16px;
        }
    }
`;

export const Preview = styled.img<{ $done: boolean }>`
    height: ${({ $done }) => getCardHeight($done, false)};
    position: absolute;
    border-radius: ${borderRadius('medium')};
    bottom: 0;
    right: 0;

    ${mediaQueries.laptop} {
        height: ${({ $done }) => getCardHeight($done, true)};
    }
`;

export const Checkmark = styled(CheckIcon)<HTMLAttributes<SVGElement>>`
    position: absolute;
    right: 39px;
    width: 56px;
    height: 56px;
    top: 50%;
    transform: translateY(-50%);

    ${mediaQueries.laptop} {
        right: 33px;
        width: 72px;
        height: 72px;
    }
`;
